goog.provide('el8.uiwidget.FormButtonSet');

goog.require('el8.model.base');
goog.require('el8.uiwidget.ButtonSet');


/**
 * A slight modification of the ButtonSet for use in the FormDialog,
 * which accounts for the fact that FormDialogs are likely to throw
 * JS links (<a>) into the HTML inside their <form>.
 */
el8.uiwidget.FormButtonSet = function(form) {
    /**
     * @param form {el8.uiwidget.Form}
     */
    this._form = form;
    el8.uiwidget.ButtonSet.call(this);
};
el8.uiwidget.FormButtonSet.inheritsFrom(el8.uiwidget.ButtonSet);

el8.uiwidget.FormButtonSet.prototype.bindEvents = function() {

    if (this._eventsBound) { return; }

    var that = this;
    this._container.on('click', 'button, a:not([href])',  function(e) {
        e.preventDefault();
        if (that._enabled) {
            var $btn = $(this);
            var name = $btn.attr('name');
            if (name && that._clickMap[name]) {
                var retVal = that._clickMap[name].call(that, that._form, $btn);
                if (retVal === false) { return false; }
            }
        }
    });

    this._eventsBound = true;
    return this;
};

el8.uiwidget.FormButtonSet.prototype.unbindEvents = function() {
    if (!this._eventsBound) { return; }
    this._container.off('click', 'button, a:not([href])');
    this._eventsBound = false;
    return this;
};
